<template>
    <div :class="{sidebar:true,collapse:collapse}">

        <scrollbar>

            <div class="logo">
                <slot name="logo">
                    <!--                    <span v-if="!collapse" class="text">{{sysName}}</span>-->
                    <span v-if="!collapse" class="img">
                        <img v-if="appInfo.logoUrl" :src="appInfo.logoUrl" style="height: 100%;" alt="">
                        <img v-else src="../../assets/cloudgo_logo.png" style="height: 100%;" alt="">
                    </span>
                </slot>
                <slot name="collapse-logo">
                    <span v-if="collapse" class="text">{{collapseSysName}}</span>

                </slot>
            </div>

            <transition name="el-fade-in-linear">

                <el-menu
                        v-if="showMenu"
                        :collapse="collapse"
                        :default-active="$route.fullPath"
                        style="margin-top: 30px;"
                        class="el-menu"
                        background-color="#242C37"
                        text-color="#b3b9bf"
                        active-text-color="#ffffff">

                    <template v-for="(firstItem,firstIndex) in sidebarData">

                        <el-submenu v-if="firstItem.children && firstItem.children.length" :index="firstItem.url"
                                    v-bind:key="firstIndex">
                            <template slot="title">
                                <i v-if="firstItem.icon" :class="menuItemIconClass(firstItem.icon)"></i>
                                <span slot="title">{{firstItem.name}}</span>
                            </template>

                            <template v-for="(secondItem,secondIndex) in firstItem.children">

                                <el-submenu class="fb-submenu" v-if="secondItem.children && secondItem.children.length"
                                            :index="secondItem.url" v-bind:key="firstIndex + '-' +  secondIndex">
                                    <template slot="title">
                                        <i v-if="secondItem.icon" :class="menuItemIconClass(secondItem.icon)"></i>
                                        <span slot="title">{{secondItem.name}}</span>
                                    </template>

                                    <template v-for="(thirdItem,thirdIndex) in secondItem.children">

                                        <el-menu-item :index="thirdItem.url"
                                                      v-bind:key="firstIndex + '-' +  secondIndex + '-' + thirdIndex"
                                                      @click="handlePush(thirdItem.url)">
                                            <i v-if="thirdItem.icon" :class="menuItemIconClass(thirdItem.icon)"></i>
                                            <span slot="title">{{thirdItem.name}}</span>
                                        </el-menu-item>

                                    </template>


                                </el-submenu>

                                <el-menu-item v-else :index="secondItem.url"
                                              v-bind:key="firstIndex + '-' +  secondIndex"
                                              @click="handlePush(secondItem.url)">
                                    <i v-if="secondItem.icon" :class="menuItemIconClass(secondItem.icon)"></i>
                                    <span slot="title">{{secondItem.name}}</span>
                                </el-menu-item>

                            </template>


                        </el-submenu>

                        <el-menu-item v-else :index="firstItem.url" v-bind:key="firstIndex"
                                      @click="handlePush(firstItem.url)">
                            <i v-if="firstItem.icon" :class="menuItemIconClass(firstItem.icon)"></i>
                            <span slot="title">{{firstItem.name}}</span>
                        </el-menu-item>

                    </template>


                </el-menu>
            </transition>

        </scrollbar>
    </div>
</template>

<script>

    import Scrollbar from "../scrollbar/Scrollbar";

    export default {
        name: "Siderbar",
        components: {Scrollbar},
        props: {
            appInfo: {
                type: Object,
                default: function () {
                    return {}
                }
            },

            sysName: {
                type: String,
                default: function () {
                    return "CloudGO"
                }
            },
            collapseSysName: {
                type: String,
                default: function () {
                    return "CG"
                }
            },
            collapse: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
            router: {
                type: Boolean,
                default: true
            },
            sidebarData: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            handleCollapse: {
                type: Function
            },
            showSidebar: {
                type: Boolean,
                default: true
            },
            handleClickMenu: {
                type: Function,
                default: function () {

                }
            }
        },
        data() {
            return {
                showMenu: true
            }
        },
        computed: {},
        methods: {
            handlePush(url){
                if(url.startsWith("http")){
                    window.open(url);
                }else{
                    this.$router.push(url);
                }
            },
            menuItemIconClass(iconClass) {
                let menuItemIconClass = {};
                menuItemIconClass[iconClass] = true;
                menuItemIconClass['menu-item-icon'] = true;
                return menuItemIconClass;
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>


    /* 侧边栏样式 */
    .sidebar {
        overflow: hidden;
        height: 100%;

    }


    .el-menu {
        border-right: none;
    }

    .el-menu-icon-collapse {
        color: #ffffff;
    }

    .menu-item-icon {
        font-size: 18px;
        margin-right: 10px;
    }


    /* logo样式 */
    .logo {
        text-align: center;
        padding-top: 10px;

        .text {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            padding-left: 20px;
            padding-right: 20px;
            background-color: #c01920;
            font-size: 32px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
            border-radius: 10px 10px 10px 0;
        }

        .img {
            padding-left: 20px;
            padding-right: 20px;
            height: 45px;
            background-color: #ffffff;
            display: inline-block;
            border-radius: 6px 6px 6px 0;

        }


    }

    /* 侧边栏隐藏时logo样式 */
    .collapse {

        .logo {

            .text {
                font-size: 24px;
                padding-left: 10px;
                padding-right: 10px;
            }


        }

    }

    .el-menu-item.is-active {
        background-color: #c01920 !important;
    }


</style>

